import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import classes from "./sortingItem.module.scss";
import { useRecoilValue } from "recoil";
import { userState } from "../../../../states/userState";
import { foreColor, foreColorPagination } from "../../../../commons/colors";
import classNames from "classnames";
/**
 * A simple "draggable" item for use with @dnd-kit.
 * Expects `item` prop with shape: { id: string, drawingName: string, ... }
 */
const SortableItem = ({ item }) => {
  const user = useRecoilValue(userState);
  // Grab the @dnd-kit helpers
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id });
  const mode = user?.mode === "lite" ? "Lite" : "";
  const className = classNames(classes.contentBody, {
    [classes[`contentBody--dragging${mode}`]]: isDragging,
    [classes[`contentBody--${mode.toLowerCase()}`]]: !isDragging,
  });
  // Inline styling to illustrate movement
  const style = {
    // @dnd-kit transforms items to show them “moving”; we apply that here
    transform: CSS.Transform.toString(transform),
    transition,
    border: "1px solid #ccc",
    padding: "8px 16px",
    marginBottom: "8px",
    backgroundColor: isDragging ? "#f0f7ff" : "#fff",
    cursor: "grab",
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={className}
      {...attributes}
      {...listeners}
    >
      <div
        className={classes.drawingName}
        style={foreColorPagination(user?.mode ?? "lite")}
      >
        {item.drawingName}
      </div>
      <div
        className={classes.documentName}
        style={foreColorPagination(user?.mode ?? "lite")}
      >
        {`（${item.documentName}）`}
      </div>
    </div>
  );
};

export default SortableItem;
